import { CompanyContact } from './CompanyContact'
import { ILocationCompanyContact } from '@/types/locationCompanyContact/models'

export function LocationCompanyContact(
  o: ILocationCompanyContact
): ILocationCompanyContact {
  const fn = '[cynqueModules/dataObjects/LocationCompanyContact.ts] Contact |'
  if (!o) {
    throw new Error(
      `${fn} LocationCompanyContact called with falsey locationCompanyContact`
    )
  }
  if (!o.location) {
    throw new Error(`${fn} LocationCompanyContact called with falsey location`)
  }
  if (!o.companyContact) {
    throw new Error(
      `${fn} LocationCompanyContact called with falsey companyContact`
    )
  }
  if (!o.companyContact.person) {
    throw new Error(
      `${fn} CompanyContact called with falsey companyContact.person`
    )
  }
  const obj = { ...o }
  obj.companyContact = CompanyContact(o.companyContact)
  obj.descr = obj.companyContact.descr
  obj.label = obj.companyContact.label
  console.debug(`${fn} returning`, obj)
  return obj
}
